import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import HandMouse from './components/HandMouse.vue';
import VueGoogleCharts from 'vue-google-charts';
import JsonViewer from 'vue-json-viewer';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Notifications from 'vue-notification';
import VueGAPI from 'vue-gapi';
import VueGeolocation from 'vue-browser-geolocation';
import * as VueGoogleMaps from 'vue2-google-maps';
import AudioVisual from 'vue-audio-visual';
import '@mdi/font/css/materialdesignicons.css';
import SequentialEntrance from 'vue-sequential-entrance';
import 'vue-sequential-entrance/vue-sequential-entrance.css';
import { Configuration, OpenAIApi } from 'openai';
import { EventBus } from '@/eventBus.js';
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";

// ✅ ADD THIS: import your AI utility (Code 5/6 wrapper)
import AI from '@/utils/ai'; // or: import { AI } from '@/utils/ai';

// ✅ ADD THIS: set the key ONCE at app startup
// Vue CLI only exposes env vars prefixed with VUE_APP_
// (we fallback to OPENAI_API_KEY in case your build already defines it)
const OPENAI_KEY =
  process.env.VUE_APP_OPENAI_API_KEY ||
  process.env.OPENAI_API_KEY ||
  localStorage.getItem('openai.key') ||
  null;

if (OPENAI_KEY) {
  AI.setKey(OPENAI_KEY);
  // optional: keep it available if you refresh
  // localStorage.setItem('openai.key', OPENAI_KEY);
} else {
  // Don’t throw here (it would crash the whole app). Let components show the error when AI is called.
  // console.warn("OpenAI key missing. Set VUE_APP_OPENAI_API_KEY in .env or localStorage openai.key.");
}

const configuration = new Configuration({
  organization: 'org-7wK7zYly4qM0pfGUu7IRxFPz',
  // ✅ keep your existing usage, but prefer the Vue CLI env var if present
  apiKey: process.env.VUE_APP_OPENAI_API_KEY || process.env.OPENAI_API_KEY,
});
const openai = new OpenAIApi(configuration);
Vue.use(openai);

Vue.use(SequentialEntrance);
Vue.use(Vuetify, {
  iconfont: 'mdi',
});
Vue.use(Notifications);
Vue.use(VueGoogleCharts);
Vue.use(AudioVisual);
Vue.use(JsonViewer);
Vue.config.productionTip = false;
window.Event = new Vue();

const apiConfig = {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'],
  scope: 'https://www.googleapis.com/auth/gmail.send',
  refreshToken: true,
};

Vue.use(VueGAPI, apiConfig);
Vue.use(VueGeolocation);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places',
  },
});

Vue.component('HandMouse', HandMouse);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  vuetify: new Vuetify({
    theme: {
      themes: {
        dark: {
          primary: '#78cce2',
          primary2: '#3e90a5',
          primary3: '#1e5a6f',
          color: '#1e1e1e',
          accent: '#7CB342',
          secondary: '#0c161b',
          secondary2: '#fff',
          secondary3: '#0c161b',
          success: '#4CAF50',
          info: '#6156d8',
          warning: '#1565C0',
          error: '#FF7043',
          nav: '#0c161b',
          bar: '#0c161b',
        },
        light: {
          primary: '#0c161b',
          primary2: '#162831',
          primary3: '#1e5a6f',
          accent: '#a1e754',
          secondary: '#fff',
          secondary2: '#000',
          secondary3: '#304057',
          success: '#6dff74',
          info: '#304057',
          warning: '#2e8ac0',
          error: '#ff5e3c',
        }
      },
      options: {
        customProperties: true,
      },
    },
  }),
  render: (h) => h(App),
  mounted() {
    const connectBtn = document.getElementById('connect-button');
    if (connectBtn) {
      connectBtn.addEventListener('click', () => {
        EventBus.$emit('toggleVideoEvent');
      });
    }

    const resetBtn = document.getElementById('reset-button');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        window.location = '/welcome';
      });
    }
  },
}).$mount('#app');
